<template>
  <div class="wrapper">
    <template>
      <template v-if="productsLoaded == false">
        <p class="m-0">
          {{ $t('message.loading') }}
        </p>
      </template>
      <template v-if="productsLoaded == true">
        <section>
          <section-title :title="$t('apps.inventory.message.selectwarehouse')"/>
          <div class="form-row">
            <div class="col-12">
              <select
                v-model="selectedBinLocationId"
                class="custom-select"
              >
                <option
                  v-for="(bin, index) of warehouseLocations"
                  :key="index"
                  :value="bin.bin_location_id"
                >
                  {{ bin.text }}
                </option>
              </select>
            </div>
          </div>
        </section>
        <section>
          <section-title :title="$t('message.item')"/>
          <div class="row m-0">
            <div
              v-for="(item, index) in items"
              :key="index"
              class="col-12 box mb-3"
            >
              <div class="row">
                <div :class="disabledActions?'col-12':'col-lg-11'">
                  <div class="form-row">
                    <div class="col-12 mb-2">
                      <select
                        :class="item.validateReason"
                        v-model="item.reason"
                        class="form-control form-control-sm custom-select"
                      >
                        <option
                          value=""
                          disabled>{{ $t('placeholder.selectreason').toLowerCase() }}</option>
                        <option value="manual recount">{{ $t('apps.inventory.message.recount').toLowerCase() }}</option>
                        <option value="manual received">{{ $t('apps.inventory.message.received').toLowerCase() }} +</option>
                        <option value="manual issue">{{ $t('apps.inventory.message.manualissue').toLowerCase() }} -</option>
                        <option value="manual return">{{ $t('apps.inventory.message.return').toLowerCase() }} +</option>
                        <option value="manual loss">{{ $t('apps.inventory.message.loss').toLowerCase() }} -</option>
                        <option value="manual damage">{{ $t('apps.inventory.message.damage').toLowerCase() }} -</option>
                        <option value="manual consumed production">{{ $t('apps.inventory.message.consumedproduction').toLowerCase() }} -</option>
                        <option value="manual received production">{{ $t('apps.inventory.message.receivedproduction').toLowerCase() }} +</option>
                      </select>
                    </div>
                  </div>
                  <div class="form-row">
                    <div
                      class="col-lg-9 mb-mobile-2">
                      <div
                        :class="item.validateSkuId"
                        class="wrapper-selectize"
                      >
                        <vue-bootstrap-autocomplete
                          v-model="item.queryProductName"
                          :data="optionSkus.filter(opt => selectedSkuIds.indexOf(opt.value) === -1)"
                          :serializer="(item) => item.text + ' ' + (item.sku_code || '')"
                          :minMatchingChars="1"
                          :maxMatches="10"
                          :placeholder="$t('placeholder.selectitem')"
                          :loading="item.loading"
                          :disabled="disabledActions"
                          :showCreate="false"
                          :noResultsInfo="item.loaded ? $t('message.notfounddata') : null"
                          @input="($event) => {
                            items[index].loading = true
                            lookupProducts(index, $event)
                          }"
                          @hit="handleSelectProduct(index, $event)"
                          @blur="handleBlurProduct(index, $event)"
                          @inputBlur="handleInputBlurProduct(index, $event)"
                          @keydown="handleKeydownProduct(index, $event)"
                          @keyup="handleKeyupProduct(index, $event)"
                        >
                          <template
                            slot="suggestion"
                            slot-scope="{ data, htmlText }">
                            <div class="d-flex align-items-center">
                              <img
                                :src="productImage(data.value)"
                                style="width: 40px; height: 40px; border-radius: 0.25rem;"
                              >
                              <div class="d-flex flex-column">
                                <span
                                  class="ml-4"
                                  v-html="data.text"/>
                                <span
                                  class="ml-4"
                                  style="font-size: 11px;"
                                  v-html="data.sku_code"/>
                              </div>
                            </div>
                          </template>
                        </vue-bootstrap-autocomplete>
                      </div>
                    </div>
                    <div class="col-lg-3 mb-mobile-2">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">{{ $t('message.quantity') }}</span>
                        </div>
                        <input
                          :disabled="item.sku_id.length == 0"
                          v-model="item.qty"
                          type="text"
                          class="form-control text-right number-only text-select-all"
                          @keypress="numberOnly"
                          @keyup="item.qty = setToValidNumber(item.qty)"
                          @blur="item.qty = setToCustomDigitsNumber(item.qty)"
                        >
                      </div>
                    </div>
                  </div>
                  <template v-if="item.reason.length > 0 && item.sku_id.length > 0">
                    <div class="form-row mt-0 mt-lg-2">
                      <div class="col-12">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span
                              class="input-group-text"
                              style="border-radius: 0.25em 0 0 0;">{{ currentBinLocationName }}</span>
                          </div>
                          <input
                            :disabled="true"
                            :value="getCurrentStockByBinId(item.sku_id, whId, selectedBinLocationId)"
                            type="text"
                            class="form-control text-right"
                            style="border-left: 0;border-radius: 0 0.25em 0 0;"
                          >
                        </div>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span
                              class="input-group-text"
                              style="border-top: 0px;border-radius: 0 0 0 0.25em;">
                              <i class="fas fa-sync-alt"/>
                            </span>
                          </div>
                          <input
                            :class="getFontColor(getCurrentStockByBinId(item.sku_id, whId, selectedBinLocationId), getNewCalcStock(item.reason, getCurrentStockByBinId(item.sku_id, whId, selectedBinLocationId), item.qty))"
                            :disabled="true"
                            :value="getNewCalcStock(item.reason, getCurrentStockByBinId(item.sku_id, whId, selectedBinLocationId), item.qty)"
                            type="text"
                            class="form-control text-right"
                            style="border-left: 0px; border-top: 0; border-radius: 0 0 0.25em 0;"
                          >
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
                <div
                  v-if="!disabledActions"
                  class="col-lg-1 pl-lg-0 mt-2 mt-lg-0">
                  <button
                    type="button"
                    class="btn btn-block h-100"
                    @click="del(index)">
                    <i class="far fa-trash-alt"/>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section v-if="!disabledActions">
          <button
            class="btn"
            @click="add()">{{ $t('button.addproduct') }}</button>
        </section>
      </template>
    </template>
  </div>
</template>

<script>
import SelectizeVue from 'vue2-selectize'
import { mapGetters } from 'vuex'
import _, { debounce, cloneDeep } from 'lodash'
import orderAutocompleteInventoryStockControlMixin from '../../../../../mixins/orderAutocompleteInventoryStockControl'

export default {
  mixins: [orderAutocompleteInventoryStockControlMixin],
  components: {
    SelectizeVue,
  },
  props: {
    // if send sku_id to this component
    // that mean user clicked on that item
    // and want to transfer immediately
    // no add more items
    // no remove an item
    sku_id: {
      type: String,
    },
    reason: {
      type: String,
    },
  },
  data () {
    return {
      cloneDeep,
      productsAvailable: [],
      optionSkus: [],
      items: [],
      whId: null,
      productsLoaded: false,
      selectedBinLocationId: null,
    }
  },
  computed: {
    ...mapGetters({
      products: 'getProducts',
      warehouses: 'getWarehouses',
      getWarehouseInfo: 'getWarehouseInfo',
      getSkuInfoBySkuId: 'getSkuInfoBySkuId',
      isAssignedInWarehouse: 'isAssignedInWarehouse',
      stocks: 'getStocks',
      isBinIdExist: 'isBinIdExist',
      getProductInfoBySkuId: 'getProductInfoBySkuId',
      defaultImages: 'getDefaultImages',
    }),
    // disabled for default sku_id
    disabledActions () {
      return this.sku_id != null
    },
    // emit out of this component to use this data for api call
    filterItems () {
      var results = []
      this.items.map(item => {
        if (item.reason.length > 0 && item.sku_id.length > 0) {
          var dataSet = {
            'sku_id': item.sku_id,
            'stock_id': this.getStockId(this.whId, item.sku_id),
            'warehouse_id': this.whId,
            'bin_location_id': this.selectedBinLocationId,
            'quantity': parseFloat(item.qty),
            'reason': item.reason,
            'note': null,
          }
          results.push(dataSet)
        }
      })
      return results
    },
    fromWarehouseName () {
      if (this.whId) {
        return this.getWarehouseInfo(this.whId).warehouse_name
      }
      return null
    },
    selectedSkuIds () {
      var arr = []
      this.items.map(item => {
        if (item.sku_id.length > 0) {
          arr.push(item.sku_id)
        }
      })
      return arr
    },
    defaultBinLocationId() {
      if (this.disabledActions === false) {
        return null
      }
      const stock = this.stocks.find((stock) => (
        stock.sku.sku_id === this.sku_id && stock.warehouse.warehouse_id === this.whId
      ))
      if (!stock) {
        return null
      }

      const primaryBinId = stock.stock.primary_bin_location_id
      if (primaryBinId && this.isBinIdExist(primaryBinId)) {
        return primaryBinId
      }

      const stockLocations = stock.stock_locations.filter((stockLocation) => stockLocation.bin_location_id != null)
      return stockLocations.length === 1
        ? stockLocations[0].bin_location_id
        : null
    },
    warehouseLocations() {
      return this.warehouses.reduce((acc, cur) => {
        const wh = cur
        if (wh.warehouse_id === this.whId) {
          if (wh.bin_locations.length > 0) {
            wh.bin_locations.forEach((bin) => {
              acc.push({
                text: `${this.fromWarehouseName} - ${bin.code}`,
                wh_id: wh.warehouse_id,
                bin_location_id: bin._id,
              })
            })
          }
        }
        return acc
      }, [{
        text: this.fromWarehouseName,
        wh_id: this.whId,
        bin_location_id: null,
      }])
    },
    currentBinLocationName () {
      const item = this.warehouseLocations.find((whLocation) => whLocation.bin_location_id === this.selectedBinLocationId)
      return item.text
    },
  },
  watch: {
    filterItems () {
      this.$emit('update:data', {
        'items': this.filterItems,
      })
    },
    selectedSkuIds () {
      if (this.selectedSkuIds.length == this.optionSkus.length) {
        return // end this line
      }
      this.items.map((item, index) => {
        if (item.sku_id.length == 0) {
          item.options = _.cloneDeep(this.optionSkus.filter(opt => this.selectedSkuIds.indexOf(opt.value) === -1))
        } else {
          // var tempSkuId = _.cloneDeep(item.sku_id)
          // item.options.map((opt, idx) => {
          //   if(this.selectedSkuIds.indexOf(opt.value) > -1 && opt.value != item.sku_id) {
          //     item.options.splice(idx, 1)
          //     setTimeout(()=>{
          //       this.items[index].sku_id = tempSkuId
          //     }, 1)
          //   }
          // })
        }
      })
    },
    'items': {
      handler: function () {
        this.items.map((item, index) => {
          var isSelectedReason = item.reason.length > 0
          var isSelectedSku = item.sku_id.length > 0
          if (isSelectedReason || isSelectedSku) {
            item.validateReason = !isSelectedReason ? 'is-invalid' : ''
            item.validateSkuId = !isSelectedSku ? 'is-invalid' : ''
          }
        })
      },
      deep: true,
    },
  },
  created: async function () {
    this.setData()

    // add items for default.
    this.add(this.sku_id)

    if (this.sku_id) {
      const response = await this.$store.dispatch('getProduct', {
        sku_id: this.sku_id,
      })
      const products = response.data
      this.tempProducts = [
        ...this.tempProducts,
        ...products,
      ]
      const product = products[0]
      this.items[0].queryProductName = this.getProductFullName(product.product_name, product.prices[0].attributes)
      this.items[0].sku_code = product.prices[0].sku_code
    }

    this.productsLoaded = true
    this.showFinish(this.$Progress)
  },
  mounted() {
    this.$nextTick(() => {
      this.selectedBinLocationId = this.defaultBinLocationId
    })
  },
  methods: {
    setOptionSkus () {
      this.optionSkus = []
      for (let i in this.productsAvailable) {
        let item = this.productsAvailable[i]
        this.optionSkus.push({
          text: item.product_name,
          sku_code: item.sku_code,
          value: item.sku_id,
        })
      }
    },
    setProductsAvailable () {
      this.productsAvailable = []
      for (let i in this.products) {
        let product = this.products[i]
        for (let j in product.prices) {
          let price = product.prices[j]
          const pass = this.isAssignedInWarehouse(price.sku_id, this.$route.query.wh_id)
          if (pass) {
            this.productsAvailable.push({
              product_name: this.getProductFullName(product.product_name, price.attributes),
              sku_id: price.sku_id,
              price: price.price || 0,
              cost: price.cost || 0,
              unit: product.unit,
              sku_code: price.sku_code,
            })
          }
        }
      }
      for (let i in this.data) {
        this.productsAvailable.push({
          product_name: this.data[i].item,
          sku_id: this.data[i].sku_id,
          price: this.data[i].price || 0,
          cost: 0,
          unit: null,
          sku_code: this.data[i].sku_code,
        })
      }
      this.setOptionSkus()
    },
    add (skuId) {
      this.items.push({
        reason: this.reason != null ? this.reason : '',
        sku_id: skuId || '',
        qty: this.setToCustomDigitsNumber(0),
        validateReason: '',
        validateSkuId: '',
        queryProductName: '',
        sku_code: '',
        loading: false,
        loaded: false,
      })
    },
    del (index) {
      this.items.splice(index, 1)
      let that = this
      if (that.items.length == 0) {
        setTimeout(() => {
          that.add()
        }, 100)
      }
    },
    setData () {
      this.whId = this.$route.query.wh_id
    },
    getCurrentStockByBinId (sku_id, whId, binId) {
      try {
        const sku = this.getSkuInfoBySkuId(sku_id, this.tempProducts)
        const stock = sku.stocks.find((stockItem) => stockItem.warehouse_id === whId)
        const stockLocation = stock.stock_locations.find((locationItem) => locationItem.bin_location_id == binId)
        return this.setToCustomDigitsNumber(stockLocation.instock != null ? stockLocation.instock : 0)
      } catch (err) {
        return this.setToCustomDigitsNumber(0)
      }
    },
    getNewCalcStock (reason, currentStock, qty) {
      var result = parseFloat(currentStock)
      currentStock = parseFloat(currentStock)
      qty = parseFloat(qty)
      switch (reason) {
        case 'manual recount':
          result = qty
          break
        case 'manual received':
        case 'manual return':
        case 'manual received production':
          result = currentStock + qty
          break
        case 'manual loss':
        case 'manual damage':
        case 'manual consumed production':
          result = currentStock - qty
          break
        case 'manual issue':
          result = currentStock - qty
          break
      }
      return this.setToCustomDigitsNumber(result)
    },
    getFontColor (curentStock, newStock) {
      curentStock = parseFloat(curentStock)
      newStock = parseFloat(newStock)
      if (curentStock == newStock) {
        return ''
      } else if (newStock > curentStock) {
        return 'text-success'
      } else {
        return 'text-danger'
      }
    },
    getStockId (whId, skuId) {
      var sku = this.getSkuInfoBySkuId(skuId, this.tempProducts)
      if (sku) {
        return sku.stocks.find(stock => stock.warehouse_id == whId).stock_id
      }
      return null
    },
  },
}
</script>

<style scoped>
  .wrapper section:last-of-type {
    margin-bottom: 0;
  }
  .box {
    padding: 15px;
    background: #F5F5F5;
  }
  .box:last-of-type {
    margin-bottom: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/inventory/stockcontrol/include/ModalAdjustment.vue